var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasHistory)?_c('action-button',_vm._b({attrs:{"title":"Back","icon":_vm.$icons.back},on:{"action":_vm.onAction}},'action-button',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }